import { render } from "./Aftercare.vue?vue&type=template&id=5aafc751&scoped=true"
import script from "./Aftercare.vue?vue&type=script&lang=js"
export * from "./Aftercare.vue?vue&type=script&lang=js"

import "./Aftercare.vue?vue&type=style&index=0&id=5aafc751&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aafc751"]])

export default __exports__